<!-- Popup Background Overlay — teleported to document.body -->
<div #overlay [ngClass]="isAboveModal?'z-51':'z-50'"
  class="fixed inset-0 left-0 top-0 flex h-[100dvh] w-screen max-w-none items-center justify-center bg-black/30 px-4">
  <!-- Popup Box -->
  <div
    class="mx-auto flex h-auto w-full max-w-80 flex-col items-center justify-between gap-5 rounded-2xl bg-white p-5 shadow-xl sm:max-w-100">
    @if (headerTxt) {
    <p [ngClass]="headerTxtClass" class="text-center font-semibold">
      {{ translatedHeader }}
    </p>
    } @if(isIcon){
    <img [ngClass]="imgClass" [src]="imgSrc" />
    }

    @if(contentHtml) {
    <div class="w-full text-center text-sm font-semibold leading-6 text-gray-800"
      [innerHTML]="contentHtml"></div>
    } @else {
    <p class="flex flex-grow items-center justify-center text-center text-sm font-semibold text-gray-800">
      {{ translatedContent }}
    </p>
    }
    <div class="flex w-full flex-row items-center gap-3" [ngClass]="{
    'justify-between': btnCancelTxt !== 'default button',
    'justify-center': btnCancelTxt === 'default button'
  }" style="direction: ltr;">
      @if(btnCancelTxt !== "default button") {
      <button type="button" (click)="cancelAction()"
        class="custom-button-secondary order-1 inline-flex h-[48px] min-w-0 flex-1 cursor-pointer items-center justify-center">
        <span class="truncate" dir="auto">{{ translatedCancelBtn }}</span>
      </button>
      }

      <button type="button" [class.dead-link]="loader" (click)="closePopup()" [ngClass]="{
      'flex-1 min-w-0': btnCancelTxt !== 'default button',
      'min-w-[130px]': btnCancelTxt === 'default button'
    }"
        class="custom-button order-2 inline-flex h-[48px] cursor-pointer items-center justify-center bg-[var(--primary-color)]">
        @if(isShowLoader && loader) {
        <span class="inline-flex min-w-0 items-center justify-center gap-2 leading-none whitespace-nowrap" dir="auto">
          <span class="loader flex-shrink-0"></span>
          <span class="truncate">{{ 'common.PROCESSING' | translate }}</span>
        </span>
        } @else {
        <span class="truncate" dir="auto">{{ translatedBtn }}</span>
        }
      </button>
    </div>
  </div>
</div>
